import { ModalProps } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';

export const PaymentProgressModal = () => {
  return (
    <Modal
      width={360}
      visible
      closable={false}
      maskClosable={false}
      okButtonProps={{
        style: { cursor: 'progress', opacity: 0.5 },
        loading: true,
      }}
      cancelButtonProps={{
        style: { display: 'none' },
      }}
      okText={
        <FormattedMessage id="billing.invite.members.payment.progress.button.label" />
      }
      title={
        <FormattedMessage id="billing.invite.members.payment.progress.title" />
      }
    >
      <FormattedMessage id="billing.invite.members.payment.progress.content" />
    </Modal>
  );
};

export const PaymentSuccessModal = ({
  onOk,
  onCancel,
  message,
}: ModalProps & {
  message: string | React.ReactElement;
}) => {
  return (
    <Modal
      width={410}
      visible
      cancelButtonProps={{
        style: { display: 'none' },
      }}
      okText={
        <FormattedMessage id="billing.invite.members.payment.success.button.label" />
      }
      title={
        <FormattedMessage id="billing.invite.members.payment.success.title" />
      }
      onOk={onOk}
      onCancel={onCancel}
    >
      {message}
    </Modal>
  );
};

export const PaymentFailureModal = ({ onOk, onCancel }: ModalProps) => {
  return (
    <Modal
      width={410}
      visible
      okText={
        <FormattedMessage id="billing.invite.members.payment.failure.ok.button.label" />
      }
      title={
        <FormattedMessage id="billing.invite.members.payment.failure.title" />
      }
      onOk={onOk}
      onCancel={onCancel}
    >
      <FormattedMessage id="billing.invite.members.payment.failure.content" />
    </Modal>
  );
};
